import React from 'react';
import { dayTitle } from '../utils';

const DayNav = ({ date, onPrev, onNext, onToday }) => (
    <div className="pc-sched-wk">
        <button type="button" onClick={onPrev} aria-label="Предыдущий день">‹</button>
        <button type="button" onClick={onToday}>Сегодня</button>
        <span className="range">{dayTitle(date)}</span>
        <button type="button" onClick={onNext} aria-label="Следующий день">›</button>
    </div>
);

export default DayNav;
